'use strict';

if (window.dnaResourceBaseUrl) {
  __webpack_public_path__ = window.dnaResourceBaseUrl;
}

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  window.onunhandledrejection = function onunhandledrejection(e) {
    console.log('unhandled', e.reason, e.promise);
  };

  window.Promise = require('core-js/es6/promise');
} // fetch() polyfill for making API calls.


require('whatwg-fetch'); // URL and URLSearchParams polyfill for making IE 11.


require('url-polyfill/url-polyfill');
/* IE11 requires all of the following polyfills. **/


require('core-js/fn/array/includes');

require('core-js/es6/object');

require('core-js/es6/symbol');

require('core-js/es6/object');

require('core-js/es6/function');

require('core-js/es6/parse-int');

require('core-js/es6/parse-float');

require('core-js/es6/number');

require('core-js/es6/math');

require('core-js/es6/string');

require('core-js/es6/date');

require('core-js/es6/array');

require('core-js/es6/regexp');

require('core-js/es6/map');

require('core-js/es6/set');

require('blueimp-canvas-to-blob'); // содрано из react-scripts 1.1.4
// полифил для requestAnimationFrame для jsdom


if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}